import '@rio-cloud/iframe-resizer/child';

import { Outlet } from 'react-router';

const PageLayout = () => <Outlet />;

export default PageLayout;
